import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import AppBar, { AppBarMobile } from '@quintoandar/cozy-core/AppBar';
import IconButton from '@quintoandar/cozy-core/IconButton';
import ArrowBack from '@quintoandar/cozy-icons/ArrowBack';
import Search from '@quintoandar/cozy-icons/Search';
import messages from './messages';

export const SecondaryPageAppBar = ({
  searchBar,
  onArrowBackButtonClick,
  onSearchButtonClick,
  showSearchButton,
  title,
}) => {
  const intl = useIntl();

  const renderSearch = React.isValidElement(searchBar) ? searchBar : null;

  const renderMobileAppBar = (id) => (
    <AppBarMobile
      aria-label={`secondarypage-app-bar-${id}`}
      searchBar={renderSearch}
      title={title && intl.formatMessage(title)}
      navigationIcon={{
        icon: ArrowBack,
        onClick: onArrowBackButtonClick,
        'aria-label': intl.formatMessage(messages.arrowBackAriaLabel),
      }}
      pageActions={
        showSearchButton && (
          <IconButton
            icon={Search}
            aria-label={intl.formatMessage(messages.searchIconAriaLabel)}
            onClick={onSearchButtonClick}
          />
        )
      }
    />
  );

  return (
    <AppBar
      desktop={renderMobileAppBar('desktop')}
      mobile={renderMobileAppBar('mobile')}
    />
  );
};
SecondaryPageAppBar.propTypes = {
  onArrowBackButtonClick: PropTypes.func,
  onSearchButtonClick: PropTypes.func,
  searchBar: PropTypes.element,
  showSearchButton: PropTypes.bool.isRequired,
  title: PropTypes.object,
};

export default SecondaryPageAppBar;
